import { useState, useEffect } from "react";
import useFetch from "Hooks/useFetch";

let cachedSegments = null;
let inflightSegmentsPromise = null;

const GetLinks = () => {
  const [data, setData] = useState(cachedSegments);
  const { fetchData } = useFetch();

  useEffect(() => {
    if (cachedSegments) {
      setData(cachedSegments);
      return;
    }

    if (!inflightSegmentsPromise) {
      inflightSegmentsPromise = fetchData("getmarketsegments")
        .then((segments) => {
          const formatted = segments?.segments?.map((segment) => ({
            ...segment,
            slug: `/market-segments/${segment.slug}`,
          }));
          cachedSegments = formatted;
          return formatted;
        })
        .catch((err) => {
          inflightSegmentsPromise = null;
          throw err;
        });
    }

    inflightSegmentsPromise
      .then((result) => setData(result))
      .catch((error) => console.error("Error fetching market segments:", error));
  }, []);

  const links = [
    {
      name: "About us",
      mega: true,
      pages: [
        {
          name: "Company Profile",
          slug: "/company-profile",
        },
        {
          name: "Awards and certification",
          slug: "/awards-and-certification",
        },
        // {
        //   name: "leadership team",
        //   slug: "/our-team",
        // },
        {
          name: "ISO",
          slug: "/ISO",
        },
      ],
    },
    {
      name: "Solutions ",
      mega: true,
      pages: data, // Use the dynamic data
    },
    {
      name: "Brands",
      path: "/main-products",
    },
    {
      name: "Services",
      path: "/services",
    },
    {
      name: "Projects",
      path: "/main-projects",
    },
    {
      name: "academy",
      path: "/academy",
    },
    {
      name: "Careers",
      path: "/carrers",
    },
    {
      name: "news",
      path: "/news",
    },
    {
      name: "Contact",
      path: "/contact-us",
    },
  ];

  return links;
};

export default GetLinks;
